var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-rating-menu',{attrs:{"attribute":_vm.ALGOLIA_ATTRIBUTE.AVG_RATING,"max":_vm.MAX_STARS},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
var refine = ref.refine;
return [_c('RatingMenuInner',{attrs:{"items":items,"refine":refine}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }